export default {
    dashboard: `แดชบอร์ด`,
    people: 'บุคคล',
    administrators: `ผู้ดูแลระบบ`,
    customers: `ลูกค้า`,
    suppliers: `ผู้จัดส่ง`,
    retailers: `ผู้ค้าปลีก`,
    drivers: `คนขับรถ`,
    workers: `พนักงาน`,
    members: 'สมาชิก',
    products: 'สินค้า',
    items: 'รายการ',
    productItems: 'รายการสินค้า',
    categories: 'หมวดหมู่',
    brands: 'แบรนด์',
    uoms: 'หน่วยวัด',
    documents: 'เอกสาร',
    sales: 'การขาย',
    salesOrders: 'คำสั่งซื้อขาย',
    perfomaSales: 'การขายตามใบเสนอราคา',
    salesInvoices: 'ใบแจ้งหนี้ขาย',
    deliveryOrders: 'ใบส่งของ',

    cashSales: 'การขายเงินสด',
    salesDebitNotes: 'ใบลดหนี้การขาย',
    salesCreditNotes: 'ใบเพิ่มหนี้การขาย',
    replacementDeliveries: 'การจัดส่งแทน',
    retailCashSales: 'การขายเงินสดปลีก',
    retailPrescription: 'ใบสั่งยาร้านค้าปลีก',
    purchases: 'การจัดซื้อ',
    purchaseOrders: 'คำสั่งซื้อ',
    purchaseReturns: 'คืนสินค้า',
    purchaseInvoices: 'ใบแจ้งหนี้ซื้อ',

    parcel: 'พัสดุ',
    warehouse: 'คลังสินค้า',
    itemReceives: 'รับสินค้า',
    itemTransfers: 'โอนสินค้า',
    itemRelocates: 'ย้ายสินค้า',
    itemTransforms: 'แปลงสินค้า',
    itemIssues: 'เบิกสินค้า',
    itemAdjustments: 'ปรับยอดสินค้า',
    stockTakes: 'ตรวจนับสต็อก',
    transferReturns: 'การคืนสินค้าหลังโอน',
    transferRequisitions: 'คำขอโอนสินค้า',
    pickOrders: 'คำสั่งหยิบสินค้า',
    others: 'อื่น ๆ',
    operations: 'การดำเนินงาน',
    itemRelocateThreshold: 'เกณฑ์การย้ายสินค้า',
    itemReorderThreshold: 'เกณฑ์การสั่งสินค้าใหม่',
    examineInventory: 'ตรวจสอบสต็อกสินค้า',
    reports: 'รายงาน',
    delivery: 'การจัดส่ง',
    inventories: 'สินค้าคงคลัง',

    logistics: 'โลจิสติกส์',
    transporters: 'ผู้ขนส่ง',
    deliveryTrips: 'การเดินทางจัดส่ง',
    repositories: 'คลังเก็บ',
    containers: 'ภาชนะ',
    packages: 'แพ็กเกจ',
    packPackages: 'แพ็กสินค้า',
    queryPackages: 'สืบค้นแพ็กเกจ',
    groups: 'กลุ่ม',
    administratorGroups: 'กลุ่มผู้ดูแลระบบ',
    customerGroups: 'กลุ่มลูกค้า',
    supplierGroups: 'กลุ่มผู้จัดส่ง',
    settings: 'การตั้งค่า',
    rolesAndPermissions: 'บทบาทและสิทธิ์',
    business: 'ธุรกิจ',
    locations: 'สถานที่',
    regions: 'ภูมิภาค',
    countryAndRegions: 'ประเทศและภูมิภาค',
    emailGateway: 'เกตเวย์อีเมล',
    injectionProps: 'พารามิเตอร์การฉีด',
    injectionFields: 'การฉีดฟิลด์',
    customFields: 'ฟิลด์ที่กำหนดเอง',
    auditTrails: 'บันทึกการตรวจสอบ',
    taxRates: 'อัตราภาษี',
    shippingRates: 'อัตราค่าขนส่ง',
    projectProps: 'คุณสมบัติโครงการ',
    schedulers: 'ตัวตั้งเวลางาน',
    tasks: 'งาน',
    logs: 'บันทึกการดำเนินการ',
    requests: 'คำร้องขอ',
    console: 'ปลอบขวัญ',
    wallets: 'กระเป๋าเงิน',
    transactions: 'ธุรกรรม',
    walletTransactions: 'ธุรกรรมกระเป๋าเงิน',
    walletRequests: 'คำร้องกระเป๋าเงิน',
    userApiKeys: 'คีย์ API ของผู้ใช้'
}